class TbbSlider extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.destroy();
  }

  init() {
    // Prevent double initialization
    if (this.dataset.initialized) return;
    this.dataset.initialized = 'true';

    const move = this.querySelector('.tbb-slider__move');
    const moveLi = Array.from(this.querySelectorAll('.tbb-slider__move li'));
    const forword = this.querySelector('.tbb-slider__forword');
    const back = this.querySelector('.tbb-slider__back');
    const dots = this.querySelector('.tbb-slider__dots');
    const line = this.querySelector('.tbb-slider__line');
    
    if (!moveLi || moveLi.length === 0) return;
    
    this.moveLi = moveLi;
    this.counter = 1;
    this.time = 6000;
    this.line = line;
    this.dots = dots;
    
    // Clear old dots if any
    dots.innerHTML = '';
    
    for (let i = 0; i < moveLi.length; i++) {
      const dot = document.createElement('li');
      dots.appendChild(dot);
      dot.value = i;
    }
    
    this.dot = dots.getElementsByTagName('li');
    if (!this.dot || this.dot.length === 0) return;
    
    if (line) {
      line.style.animation = 'line ' + (this.time / 1000) + 's linear infinite';
    }
    this.dot[0].classList.add('active');
    
    this.moveUP = this.moveUP.bind(this);
    this.moveDOWN = this.moveDOWN.bind(this);
    
    for (let i = 0; i < this.dot.length; i++) {
      this.dot[i].addEventListener('click', (e) => {
        this.dot[this.counter - 1].classList.remove('active');
        this.counter = e.target.value + 1;
        this.dot[e.target.value].classList.add('active');
        this.moveLi[0].style.marginLeft = '-' + (this.counter - 1) * 100 + '%';
      });
    }
    
    if (forword) forword.onclick = this.moveUP;
    if (back) back.onclick = this.moveDOWN;
    
    this.autoPlay = setInterval(this.moveUP, this.time);
    
    this.onmouseover = () => {
      clearInterval(this.autoPlay);
      if (line) line.style.animation = '';
    };
    
    this.onmouseout = () => {
      this.autoPlay = setInterval(this.moveUP, this.time);
      if (line) {
        line.style.animation = 'line ' + (this.time / 1000) + 's linear infinite';
      }
    };
    
    // Add touch swipe support for mobile
    this.setupTouch();
  }

  moveUP() {
    if (this.counter == this.moveLi.length) {
      this.moveLi[0].style.marginLeft = '0%';
      this.counter = 1;
    } else if (this.counter >= 1) {
      this.moveLi[0].style.marginLeft = '-' + this.counter * 100 + '%';
      this.counter++;
    } 

    if (this.counter == 1) {
      this.dot[this.moveLi.length - 1].classList.remove('active');
      this.dot[0].classList.add('active');
    } else if (this.counter > 1) {
      this.dot[this.counter - 2].classList.remove('active');
      this.dot[this.counter - 1].classList.add('active');
    }
  }

  moveDOWN() {
    if (this.counter == 1) {
      this.moveLi[0].style.marginLeft = '-' + (this.moveLi.length - 1) * 100 + '%';
      this.counter = this.moveLi.length;
      this.dot[0].classList.remove('active');
      this.dot[this.moveLi.length - 1].classList.add('active');
    } else if (this.counter <= this.moveLi.length) {
      this.counter = this.counter - 2;
      this.moveLi[0].style.marginLeft = '-' + this.counter * 100 + '%';   
      this.counter++;
      this.dot[this.counter].classList.remove('active');
      this.dot[this.counter - 1].classList.add('active');
    }  
  }

  setupTouch() {
    let startX = 0;
    let endX = 0;

    this.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });

    this.addEventListener('touchend', (e) => {
      endX = e.changedTouches[0].clientX;
      const diffX = startX - endX;
      if (Math.abs(diffX) > 50) {
        if (diffX > 0) {
          this.moveUP();
        } else {
          this.moveDOWN();
        }
      }
    }, { passive: true });
  }

  destroy() {
    clearInterval(this.autoPlay);
  }
}

if (!customElements.get('tbb-slider')) {
  customElements.define('tbb-slider', TbbSlider);
}